module.exports = __webpack_public_path__ + "img/EYE.dadf4e00.svg";